import appStyles from "@App/app.module.scss";

/**
 * Removes the sticky-safe scroll lock applied by `lockBodySticky()`.
 *
 * Restores normal scroll behavior on both `<html>` and `<body>` elements
 * by removing the `bodyLockedSticky` class (which uses `overflow: clip`).
 *
 * @see lockBodySticky — applies the lock
 */
const unlockBodySticky = (): void => {
  document?.body?.classList?.remove(appStyles.bodyLockedSticky);
  const html = document?.getElementsByTagName("html");
  html?.[0]?.classList.remove(appStyles.bodyLockedSticky);
};

export default unlockBodySticky;
